// extracted by mini-css-extract-plugin
export var pillWrapper = "_oc-0";
export var showOverflow = "_oc-1";